import React from 'react';
import 'styles/LegacyWrapper.styl';
import {isEmbedded} from 'utils/mediafly/isEmbedded';
import {DashboardNav} from './DashboardNav';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import AuthStore from 'stores/AuthStore';

interface LegacyWrapperProps {
  location: RouterLocation;
}

/**
 * Wrapper for the non-embed version of the application.
 * Handles the nav bar, and importing global components
 */
export default class LegacyWrapper extends React.Component<LegacyWrapperProps> {
  render() {
    const {location, children} = this.props;
    const {solutionList} = AuthStore.getState().user;
    const primaryNavShown = solutionList && solutionList.length > 0;
    let justifyContentValue = 'center';
    if (
      isEmbedded() ||
      primaryNavShown ||
      window.innerWidth < 1500 // Dashboard is a static 1500px, and the largest page.
    ) {
      // If the user is in embedded mode, or they have the primary nav showing,
      // or they're on a screen without enough width to fit the dashboard,
      // justify everything left
      justifyContentValue = 'flex-start';
    }
    return (
      <div className="legacy-wrapper">
        <DashboardNav location={location} />
        <div
          className="child-view"
          style={{
            justifyContent: justifyContentValue,
          }}>
          {children}
        </div>
      </div>
    );
  }
}
